export default function Loading() {
    return (
        <>
            <div className="loader">
                <div className="ball-pulse-sync">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </>
    )
}